import React, { useState, useRef, useEffect } from 'react';
import { FileUpload } from 'primereact/fileupload';
import FileItem from './file-item/FileItem';
import { ErrorTemplate, SuccessTemplate } from '../common/ToastMessage/Template.jsx';
import { getFileIconByExtension } from '../../helpers/fileHelpers.js';
import { downloadFile } from '../../services/fileService.js'; 
const FileUploader = ({translation, invalidMessage, maxFileNumber = 0, autoUpload = true, maxFileSize = 5 * 1024 * 1024, allowedFileTypes, onUploadFile , uploadedFiles, removeFile}) => {
  // const { t } = useTranslation('common_ns');
  const fileUploadRef = useRef(null);
  const fileInputRef = useRef(null);
  const [uploadedFilesState, setUploadedFilesState] = useState([]);
  const handleTemplateClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  useEffect(() => {
    setUploadedFilesState(uploadedFiles);
  }, [uploadedFiles])

  const buildFileObject = (file) => {
    const fileObject = {
      id: uploadedFilesState.length,
      identifier: file.name + uploadedFilesState.length,
      fileResource: file,
      url: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
      progress: 0,
      state: 'UPLOADING',
      lastModifiedDate: new Date().toLocaleDateString(),
      errorMessage: '',
      icon: getFileIconByExtension(URL.createObjectURL(file)),
    };
    setUploadedFilesState((prevFiles) => [...prevFiles, fileObject]);
    if (fileObject.size > maxFileSize) {
      fileObject.errorMessage = invalidMessage.uploadFileTooLarge + `(> ${maxFileSize/(1024 * 1024)}MB)`;
      fileObject.state = 'ERROR';
    } else if (autoUpload) {
      const success = onUploadFile(fileObject);

      if (!success) {
        fileObject.errorMessage = invalidMessage.uploadFileNotSupport;
        fileObject.state = 'ERROR';
      }
      else {
        uploadFileToServer(fileObject);
      }

    } else {
      fileObject.state = 'UPLOADED';
    }
    return fileObject;
  };

  const uploadFileToServer = (fileObject) => {
    // Simulate file upload
    setTimeout(() => {
      fileObject.progress = 100;
      fileObject.state = 'UPLOADED';
      setUploadedFilesState((prevFiles) => [...prevFiles]);
    }, 2000);
  };

  const onSelectFile = (e) => {
    HandleUploadFile(e.files[0]);
    fileUploadRef?.current?.clear();
  };

  const HandleUploadFile = (file) => {
    const isDuplicate = uploadedFilesState.some((item) => item.name === file.name);
    if (isDuplicate) return;

    if (maxFileNumber !== 0 && uploadedFilesState.length >= maxFileNumber) {
      // setUploadedFilesState((prevFiles) => prevFiles.filter((item) => item.name !== file.name));
    }
    buildFileObject(file);

    // if (fileObject) {setUploadedFilesState((prevFiles) => [...prevFiles, fileObject]);}
  };

  const getUploadingFiles = () => {
    return uploadedFilesState.filter((file) => file.state === 'UPLOADING' || file.state === 'ERROR');
  };

  const getUploadedFiles = () => {
    return uploadedFilesState.filter((file) => file.state === 'UPLOADED');
  };

  const cancelFile = (file, i) => {
    removeFile(i)
  };

  const handleRemoveFile = (file, i) => {
    removeFile(i)
  };

  const handleDownloadFile = async (file) => {
    try {
      const response = await downloadFile({
          url: file.url,
          fileName: file.name
        });

      if (!response.ok) {
        return;
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        return;
    }
  };

  const retryFile = (fileObject) => {
    if (fileObject.size > maxFileSize) {
      return;
    }
    if (fileObject.fileResource) {
      onUploadFile(fileObject);

      uploadFileToServer(fileObject);
    }
  };

  const uploadTemplate = () => {
    return (<p onClick={handleTemplateClick} className="p-4 flex flex-column justify-content-center align-content-center align-items-center gap-2 cursor-pointer">
          <span className="keduall-typography text-default-txt text-16-medium-500">
            {translation.uploadFileAttachFile}
          </span>
          <span className="keduall-typography text-third-txt text-14-normal-400">
            {translation.uploadFileDragDrop} <span className="keduall-typography text-secondary-txt">{translation.uploadFileBrowseFile}</span>
          </span>
        </p>);
  }

  return (
    <div className="keduall-attachment w-full gap-2 flex flex-column">
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={(e) => {onSelectFile({ files: e.target.files }); e.target.value = null; }}
        accept={allowedFileTypes}
      />
      <FileUpload
        ref={fileUploadRef}
        customUpload
        accept={allowedFileTypes}
        multiple={false}
        onSelect={onSelectFile}
        chooseLabel={ translation.uploadFileAttachFile }
        itemTemplate={uploadTemplate()}
        emptyTemplate={uploadTemplate()}
      />
      <div className="upload-result flex flex-column gap-2">
        {getUploadingFiles().length > 0 && (
          <div className="uploading-file-content flex flex-column gap-2">
            <div className="text-default-txt keduall-typography text-16-normal-400">
              {translation.uploadFileLoading}: {getUploadingFiles().length}/{uploadedFilesState.length} {translation.uploadFileLowercase}
            </div>
            {getUploadingFiles().map((fileObject, i) => (
              <FileItem
                key={fileObject.identifier}
                source={fileObject}
                onFileRemoved={(f) => handleRemoveFile(f, i)}
                onFileDownload={handleDownloadFile}
                onFileRetry={retryFile}
                onFileCancel={(f) => cancelFile(f,i)}
                translation={translation}
              />
            ))}
          </div>
        )}
        {getUploadedFiles().length > 0 && (
          <div className="uploaded-file-content flex flex-column gap-2">
            <div className="text-default-txt keduall-typography text-16-normal-400">
              {translation.uploadFileLoaded}:
            </div>
            {getUploadedFiles().map((fileObject, i) => (
              <FileItem
                key={fileObject.identifier}
                source={fileObject}
                onFileRemoved={(f) => handleRemoveFile(f, i)}
                onFileDownload={handleDownloadFile}
                translation={translation}
                onFileRetry={retryFile}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploader; 